// store/modules/taskpage.js
const getDefaultState = () => {
    return {
      singleView: false,
      hideFooter: false,
      autoCheckin: false,
      spot: null,
    };
  };
  
  const state = getDefaultState();
  
  const getters = {
    singleView: (state) => state.singleView,
    hideFooter: (state) => state.hideFooter,
    autoCheckin: (state) => state.autoCheckin,
    spot: (state) => state.spot,
  };
  
  const mutations = {
    SetSingleView(state, singleView) {
      state.singleView = singleView;
    },
    SetHideFooter(state, hideFooter) {
      state.hideFooter = hideFooter;
    },
    SetAutoCheckin(state, autoCheckin) {
      state.autoCheckin = autoCheckin;
    },
    SetSpot(state, spot) {
      state.spot = spot;
    },
    resetState(state) {
      Object.assign(state, getDefaultState());
    },
  };
  
  export default {
    namespaced: true,
    state,
    getters,
    mutations,
  };
  